export const fmtTime = (iso: string | null | undefined): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  // dd.mm.yy HH:MM в МСК
  const date = d.toLocaleDateString('ru-RU', {
    day: '2-digit', month: '2-digit', year: '2-digit', timeZone: 'Europe/Moscow',
  });
  const time = d.toLocaleTimeString('ru-RU', {
    hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow',
  });
  return `${date} ${time}`;
};

export const ticketNumber = (n: number): string => `SD-${String(n).padStart(4, '0')}`;

export const STATUS_LABEL: Record<string, string> = {
  new: 'Новый',
  open: 'В работе',
  pending_customer: 'Ждём',
  on_hold: 'На паузе',
  resolved: 'Решён',
  closed: 'Закрыт',
  cancelled: 'Отменён',
};

export const PROJECT_LABEL: Record<string, string> = {
  support: 'Поддержка',
  pilot: 'Пилот',
  no_support: 'Нет',
};

export const PROJECT_BADGE: Record<string, string> = {
  support: 'bg-green-900/40 text-green-300 border-green-800',
  pilot: 'bg-purple-900/40 text-purple-300 border-purple-800',
  no_support: 'bg-slate-800 text-slate-500 border-slate-700',
};

export const STATUS_COLOR: Record<string, string> = {
  new: 'bg-blue-900/40 text-blue-300 border-blue-800',
  open: 'bg-yellow-900/30 text-yellow-300 border-yellow-800',
  pending_customer: 'bg-orange-900/30 text-orange-300 border-orange-800',
  on_hold: 'bg-slate-800 text-slate-400 border-slate-700',
  resolved: 'bg-green-900/30 text-green-300 border-green-800',
  closed: 'bg-slate-800 text-slate-500 border-slate-700',
  cancelled: 'bg-red-900/20 text-red-400 border-red-900',
};

// Спец-стиль для тикетов на L3: фактический статус на бэке = on_hold,
// но UI должен ясно показывать что задача ушла в R&D / Redmine.
export const L3_COLOR =
  'bg-amber-900/40 text-amber-300 border-amber-700';

/** Подпись статуса с учётом эскалации в L3 (Redmine). */
export function ticketStatusLabel(t: { status: string; redmine_issue_id?: number | null }): string {
  if (t.redmine_issue_id && t.status === 'on_hold') return 'На L3 (Redmine)';
  return STATUS_LABEL[t.status] || t.status;
}

/** Цвет статуса с учётом эскалации в L3. */
export function ticketStatusColor(t: { status: string; redmine_issue_id?: number | null }): string {
  if (t.redmine_issue_id && t.status === 'on_hold') return L3_COLOR;
  return STATUS_COLOR[t.status] || 'bg-slate-800 text-slate-300';
}

export const PRIORITY_COLOR: Record<string, string> = {
  P1: 'bg-red-700 text-white',
  P2: 'bg-orange-600 text-white',
  P3: 'bg-blue-700 text-white',
  P4: 'bg-slate-700 text-slate-300',
};

export const SLA_COLOR: Record<string, string> = {
  green:  'bg-green-900/40 text-green-300 border-green-800',
  yellow: 'bg-yellow-900/40 text-yellow-300 border-yellow-800',
  orange: 'bg-orange-900/50 text-orange-300 border-orange-800',
  red:    'bg-red-900/60 text-red-200 border-red-700 font-bold',
  ok:     'bg-slate-800 text-slate-500 border-slate-700',
};
